import {ProblemDetails} from '../types';

export class ProblemDetailsError extends Error {
    problemDetails: ProblemDetails;

    constructor(problemDetails: ProblemDetails) {
        super(problemDetails.title ?? undefined);
        this.name = 'ProblemDetailsError';
        this.problemDetails = problemDetails;
    }
}

export default ProblemDetailsError;
